import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';

const StyledLabel = styled.div(() => {
  return {
    fontSize: '11px',
    lineHeight: '150%',
    fontWeight: 600,
    color: 'rgba(10, 11, 12, 1)',
  };
});

interface ILabelProps extends PropsWithChildren {
  className?: string;
}

export const Label = ({
  className,
  children,
}: ILabelProps) => {
  return (
    <StyledLabel className={className}>
      {children}
    </StyledLabel>
  );
};
